"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownStepProcessStatus = void 0;
var DropdownStepProcessStatus;
(function (DropdownStepProcessStatus) {
    DropdownStepProcessStatus[DropdownStepProcessStatus["hidden"] = 0] = "hidden";
    DropdownStepProcessStatus[DropdownStepProcessStatus["disabled"] = 1] = "disabled";
    DropdownStepProcessStatus[DropdownStepProcessStatus["enabled"] = 2] = "enabled";
})(DropdownStepProcessStatus || (exports.DropdownStepProcessStatus = DropdownStepProcessStatus = {}));
/*
export const pleaseSelectOption: DropdownData = {
    Name: (window.bes && window.bes.spareparts) ? window.bes.spareparts.emptytext : "Select",
    Value: ""
};
*/
